/**
 * @generated SignedSource<<ca9ed51f6d4321d57d4ee66ba910721a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type board_workManagementBoard_queryFragment$data = {
  readonly " $fragmentSpreads": FragmentRefs<"board_workManagementBoard_BoardContent_queryFragment">;
  readonly " $fragmentType": "board_workManagementBoard_queryFragment";
};
export type board_workManagementBoard_queryFragment$key = {
  readonly " $data"?: board_workManagementBoard_queryFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"board_workManagementBoard_queryFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "board_workManagementBoard_queryFragment",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "board_workManagementBoard_BoardContent_queryFragment"
    }
  ],
  "type": "Query"
};

(node as any).hash = "04179e92d608fccfb1733f5a25c90369";

export default node;
